import React from 'react';
import {injectIntl} from "react-intl";

function JobTypeAutoSuggestField() {
  return '';
}

export default injectIntl(JobTypeAutoSuggestField);
